import { createSignal } from 'solid-js';
import type {
  MeasurementsCapabilityProvider,
  AlignmentMeasurementType,
} from '@trimble/web3d-providers';
import { createBaseMeasurementController } from '@trimble/measurements-shared';
import type {
  AlignmentMeasurementController,
  AlignmentMode,
} from './alignment-measurement.types';

export function createAlignmentMeasurementController(
  provider: MeasurementsCapabilityProvider
): AlignmentMeasurementController {
  const [cantMode, setCantModeSignal] =
    createSignal<AlignmentMode>('perpendicular');
  const [gradientMode, setGradientModeSignal] =
    createSignal<AlignmentMode>('perpendicular');

  const base = createBaseMeasurementController<AlignmentMeasurementType>(
    provider,
    {
      onInitialize: () => {
        setCantModeSignal('perpendicular');
        setGradientModeSignal('perpendicular');
      },
    }
  );

  const setCantMode = (value: AlignmentMode): void => {
    setCantModeSignal(value);
    base.update();
  };

  const setGradientMode = (value: AlignmentMode): void => {
    setGradientModeSignal(value);
    base.update();
  };

  return {
    type: 'alignment',
    ...base,
    cantMode,
    gradientMode,
    setCantMode,
    setGradientMode,
  };
}
